// Project Imports
import axiosInstance from 'providers/axiosInstance/axiosInstance';

type DeleteParams = {
  apiUrl: string;
  resource: string;
  id?: number | string;
  variables?: Record<string, any>;
};

const deleteOne = async ({ resource, id, apiUrl, variables }: DeleteParams) => {
  const hasId = id !== undefined && id !== null && id !== '';
  const url = hasId ? `${apiUrl}/${resource}/${id}/` : `${apiUrl}/${resource}`;

  const { data } = await axiosInstance.delete(url, { data: variables });
  return {
    data,
  };
};

export default deleteOne;
